module.exports = __webpack_public_path__ + "media/images/application/choose-price/poulpe-10-ddc4aabf57f283029dfbac27df848030.svg";